import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import ContainerRental from './pages/ContainerRental';
import Transport from './pages/Transport';
import Jordflytning from './pages/Jordflytning';
import About from './pages/About';
import Contact from './pages/Contact';

function App() {
  return (
    <HelmetProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lej-en-container" element={<ContainerRental />} />
          <Route path="/transport" element={<Transport />} />
          <Route path="/jordflytning" element={<Jordflytning />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
        </Routes>
      </Layout>
    </HelmetProvider>
  );
}

export default App;
